import type { CourseModule } from "@/core/types";
import { lektionBildEinfuegen } from "./lektion-01-einfuegen";
import { lektionTextumbruch } from "./lektion-02-textumbruch";
import { lektionAlternativtext } from "./lektion-03-alternativtext";
import { lektionSmartArt } from "./lektion-04-smartart";
import { lektionBilderAbschluss } from "./lektion-05-abschluss";

export const modulBilder: CourseModule = {
  id: "bilder",
  title: "Bilder und Grafiken",
  summary:
    "Bilder einfügen, im Textfluss verankern und so einbinden, dass sie auch für " +
    "Screenreader und im Abbildungsverzeichnis funktionieren.",
  level: "Grundlagen",
  lessons: [
    lektionBildEinfuegen,
    lektionTextumbruch,
    lektionAlternativtext,
    lektionSmartArt,
    lektionBilderAbschluss,
  ],
};
